// TODO only load in omnitrack courses
import axios from 'axios';

/**
 * Given data for an Omnitrack tenant and a form submission, makes two calls to the tenant's public API, a POST to create the submission and a PUT to submit it.
 *
 * Returns a promise that resolves with the URL of the created submission.
 *
 * @param {string} data.formId form ID
 * @param {object} data.endUserInput keys and values for submission
 * @param {string} data.base base url of the tenant, e.g. "https://omnitrack-demo.com"
 * @param {string} data.endpoint url of API, e.g. "https://omnitrack-demo.com/api"
 * @param {string} data.tenantId Omnitrack tenant
 *
 * @returns {string} submission URL
 */
export async function callOmnitrack({
  formId,
  endUserInput,
  endpoint,
  base,
  tenantId
}: {
  formId: string;
  endUserInput: object;
  endpoint: string;
  base: string;
  tenantId: string;
}): Promise<string> {
  console.log({ endUserInput });

  const headers = {
    'x-tenant-id': tenantId,
    'Content-Type': 'application/json',
    Accept: '*/*'
  };

  const data = { formId, endUserInput };

  const response1 = await axios.request({
    url: `${endpoint}/forms/v1/public/forms/${formId}/eusubmissions`,
    method: 'POST',
    headers,
    data
  });

  const { location } = response1.headers;

  const response2 = await axios.request({
    url: `${endpoint}/forms/v1/public/forms/${formId}/eusubmissions/${location}/submit`,
    method: 'PUT',
    headers,
    data
  });

  const submissionURL = `${base}/${tenantId}/forms/assigned/${formId}/${location}`;

  if (response2.status.toString().startsWith('2')) {
    console.log(`RESPONSE RECORDED:\n${submissionURL}`);
  } else {
    throw new Error('Omnitrack did not record the submission.');
  }

  return submissionURL;
}
